/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsModifyDetails } from "../../funcs/accountsModifyDetails.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1AccountsUpdateRequestBody$inboundSchema,
};

export const tool$accountsModifyDetails: ToolDefinition<typeof args> = {
  name: "accounts_modify-details",
  description: `Update account details

Updates specified fields of an existing account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsModifyDetails(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
